<template>

<app-text>

    <app-group v-html="page.business_adverts_book_campaign_content" />

    <app-group>

        <app-input-select v-model="inputs.county" :errored="inputs.county" :label="page.business_adverts_book_campaign_county_label" :placeholder="page.business_adverts_book_campaign_county_placeholder" :options="data.counties" />
        <app-input-toggle v-model="inputs.duration" :expand="true" :errored="errored.duration" :label="page.business_adverts_book_campaign_duration_label" :options="optionsDuration" />
        <app-input-date :futureOnly="true" v-model="inputs.date" :expand="true" :errored="errored.date" :label="page.business_adverts_book_campaign_date_label" :placeholder="page.business_adverts_book_campaign_date_placeholder" />

    </app-group>

	<app-group :row="true" :center="true">

		<app-button :text="page.business_adverts_book_campaign_button_proceed" :loading="is.submitting" :disabled="!is.valid" v-on:click="$emit('proceed', inputs)" />
		<app-button :text="page.business_adverts_book_campaign_button_cancel" theme="plain" v-on:click="$emit('back')" />

	</app-group>

</app-text>

</template>

<script>

import mixinForm from '@/mixin/form.js'

export default {

	mixins: [mixinForm],

	data: function() {

		return {
			inputs: {
                county: 0,
                duration: 1,
                date: 0
			},
			rules: {
                county: {
                    required: true
                },
                duration: {
                    required: true
                },
                date: {
                    required: true
                }
			}
		}

    },

    created: function() {

        if (this.$route.meta.cancel) {

            var inputs = this.$store.getters['memory']['adverts/book'] || {}

            this.inputs.county = inputs.county 
            this.inputs.duration = inputs.duration 
            this.inputs.date = inputs.date
            
        } else {

            this.inputs.county = this.session.address.county

        }

    },

    computed: {

        optionsDuration: function() {

            return {
                1: 'Short (' + this.page.business_adverts_book_campaign_short_days + ' day)',
                2: 'Medium (' + this.page.business_adverts_book_campaign_medium_days + ' days)',
                3: 'Long (' + this.page.business_adverts_book_campaign_long_days + ' days)'
            }

        }

    }

}

</script>

<style scoped>

</style>